import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

export const getConfig = (state) => {
  return state.config;
};

export const getApiKey = createSelector(getConfig, (config) => {
  if (!isEmpty(config)) {
    if (config.apiKey) {
      return config.apiKey;
    }
  }
});

export const isConfigLoading = createSelector(getConfig, (config) => {
  if (!isEmpty(config)) {
    if (config.isLoading) {
      return config.isLoading;
    }
  }
});
